import EVENT from '../enums/event.js';
import dispatchEvent from '../utils/dispatch-event.js';

const confirmToggles = (element = document.body) => {
  const toggles = [...element.querySelectorAll('[data-confirm-toggle]')];

  toggles.forEach(toggle => {
    toggle.addEventListener('click', event => {
      event.preventDefault();

      dispatchEvent(EVENT.CONFIRM.TOGGLE, toggle, {
        detail: {
          confirm: toggle.dataset.confirmToggle,
        },
      });
    });
  });
};

export default confirmToggles;
